import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { UIText1, UIText2 } from '../../typography';
import { IconFunctionalWarningCircle16, IconFunctionalWarningCircle24, IconFunctionalInformationCircle16, IconFunctionalInformationCircle24, IconFunctionalSuccessCircle16, IconFunctionalSuccessCircle24 } from '@cian/ui-kit-design-tokens/icons';
import { Spinner } from '../../loader';
import { CloseButton } from '../../internal/components/CloseButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Status = _ref => {
  let {
    status = 'info',
    size = 'M'
  } = _ref;
  const sizePx = size === 'S' ? '16' : '24';
  const statusIcons = {
    info16: /*#__PURE__*/_jsx(IconFunctionalInformationCircle16, {
      color: "icon-main-default"
    }),
    info24: /*#__PURE__*/_jsx(IconFunctionalInformationCircle24, {
      color: "icon-main-default"
    }),
    error16: /*#__PURE__*/_jsx(IconFunctionalWarningCircle16, {
      color: "icon-negative-default"
    }),
    error24: /*#__PURE__*/_jsx(IconFunctionalWarningCircle24, {
      color: "icon-negative-default"
    }),
    success16: /*#__PURE__*/_jsx(IconFunctionalSuccessCircle16, {
      color: "icon-positive-default"
    }),
    success24: /*#__PURE__*/_jsx(IconFunctionalSuccessCircle24, {
      color: "icon-positive-default"
    }),
    spinner16: /*#__PURE__*/_jsx(Spinner, {
      color: "icon-secondary-default",
      size: 16
    }),
    spinner24: /*#__PURE__*/_jsx(Spinner, {
      color: "icon-secondary-default",
      size: 24
    })
  };
  return statusIcons["".concat(status).concat(sizePx)];
};

/**
 * [Ссылка на макет](https://www.figma.com/design/amgqTgkrOwLG0jVNAFEDwp/%F0%9F%8C%90-Snackbar)
 *
 * @deprecated Используйте компонент Toast
 */
export const Snackbar = /*#__PURE__*/React.forwardRef(function Snackbar(props, ref) {
  const {
    action,
    anchorOrigin: {
      vertical,
      horizontal
    } = {
      vertical: 'top',
      horizontal: 'center'
    },
    autoHideDuration = null,
    message,
    secondaryMessage,
    hideCloseButton,
    onClose,
    open,
    size = 'M',
    status
  } = props;
  const timerAutoHide = React.useRef(undefined);
  const [shouldRender, setShouldRender] = React.useState(open);
  React.useEffect(() => {
    if (open) {
      setShouldRender(true);
    }
  }, [open]);
  const setAutoHideTimer = React.useCallback(autoHideDurationParam => {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(() => {
      onClose();
    }, autoHideDurationParam);
  }, [onClose]);
  React.useEffect(() => {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return () => {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  const containerClasses = clsx(styles['container'], styles[vertical], styles[horizontal], styles[size], open ? styles['show'] : styles['hide']);
  const TextComponent = size === 'S' ? UIText2 : UIText1;
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: containerClasses,
    ref: ref,
    onAnimationEnd: () => {
      if (!open) {
        setShouldRender(false);
      }
    },
    children: [/*#__PURE__*/_jsxs("section", {
      className: styles.rightSection,
      children: [status && /*#__PURE__*/_jsx(Status, {
        size: size,
        status: status
      }), message && /*#__PURE__*/_jsx(TextComponent, {
        color: "text-inverted-default",
        children: message
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: styles.middleSection,
      children: secondaryMessage && /*#__PURE__*/_jsx("section", {
        className: styles.secondaryMessage,
        children: /*#__PURE__*/_jsx(TextComponent, {
          color: "current_color",
          children: secondaryMessage
        })
      })
    }), /*#__PURE__*/_jsxs("section", {
      className: styles.leftSection,
      children: [action && /*#__PURE__*/_jsx("div", {
        role: "button",
        onClick: action.onClick,
        className: styles.actionButton,
        children: /*#__PURE__*/_jsx(TextComponent, {
          color: "current_color",
          children: action.title
        })
      }), !hideCloseButton && !action && /*#__PURE__*/_jsx("div", {
        role: "button",
        className: styles.closeButton,
        children: /*#__PURE__*/_jsx(CloseButton, {
          className: styles['close'],
          onClick: onClose ? onClose : () => {},
          size: 12,
          theme: "dark"
        })
      })]
    })]
  });
});